module.exports = __webpack_public_path__ + "static/media/returns_P.142cbf44.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/returns_P.png
// module id = 105
// module chunks = 0